<template>
    <div class="fleet-setup-side-bar">
        <aside class="sidebar">
            <div class="logo mt-2">Fleet Setup</div>
            <ul class="steps">
                <li v-for="(step, index) in steps" :key="step.id" :class="{ active: section === step.id, complete: step.complete }" @click="navigateStep(step.id)">
                    <div class="step-content">
                        <span class="complete-icon nav" v-if="step.complete">
                            <icon name="faCheck" type="solid"></icon>
                        </span>
                        <span class="step-number" v-else>{{ index + 1 }}</span>
                        <span class="label">{{ step.label }}</span>
                    </div>

                    <div v-if="index !== steps.length - 1" :class="[{ complete: step.complete }, 'step-arrow']">
                        <icon name="faArrowDown" type="solid"></icon>
                    </div>
                </li>
            </ul>

            <div class="sidebar-help">
                <h4>Need Help?</h4>
                <p>
                    <icon name="faCircleQuestion" type="solid" class="td-text-secondary"></icon>
                    Our team is here to help you get set up.
                </p>
                <a href="/contact" class="td-link"> Contact Support </a>
            </div>
        </aside>
        <div class="mobile-stepper">
            <div class="step-top td-text-center">
                <icon v-if="showPrevious" name="faArrowLeft" type="solid" @click="stepBack" class="step-icon"> </icon>
                <strong> Step {{ currentStep }} - {{ currentStepLabel }} </strong>
                <icon v-if="showNext" class="step-icon" @click="stepForward" name="faArrowRight" type="solid"></icon>
            </div>
        </div>
    </div>
</template>

<script>
import script from './SideBar';
    export default script;</script>

<style lang="less">
    @import "./SideBar.less";
</style>